module.exports = __webpack_public_path__ + "static/eskin-5ae5762f8d99b13c2d452f319b85322d.png";